import TelegramChannelComponent from '../component';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  telegramChannelChangeCurrent,
  telegramChannelListFetch,
  telegramChannelCreateFetch,
  telegramChannelInfoFetch,
  telegramChannelDeleteFetch,
  telegramChannelUpdateFetch,
  telegramChannelViewFetch,
} from '../TelegramChannelActions';
import PropTypes from 'prop-types';

const mapStateToProps = (state) => ({
  name: state.channel.telegramChannel.name,
  botToken: state.channel.telegramChannel.botToken,
  batchSize: state.channel.telegramChannel.batchSize,
  page: state.channel.telegramChannel.page,
  info: state.channel.telegramChannel.info,
  view: state.channel.telegramChannel.view,
  pageRequest: state.channel.telegramChannel.pageRequest,
  creating: state.channel.telegramChannel.creating,
  loading: state.channel.telegramChannel.loading,
  deleting: state.channel.telegramChannel.deleting,
  updating: state.channel.telegramChannel.updating,
  retrievingData: state.channel.telegramChannel.retrievingData,
  loadingInfo: state.channel.telegramChannel.loadingInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      telegramChannelChangeCurrent,
      telegramChannelListFetch,
      telegramChannelCreateFetch,
      telegramChannelInfoFetch,
      telegramChannelDeleteFetch,
      telegramChannelUpdateFetch,
      telegramChannelViewFetch,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TelegramChannelComponent);

TelegramChannelComponent.propTypes = {
  name: PropTypes.object.isRequired,
  botToken: PropTypes.object.isRequired,
  batchSize: PropTypes.number,
};
